import { React } from 'react';
import styled from 'styled-components';

import PhoneInput from './PhoneInput';

import { ReactComponent as KeypadBackSvg } from '../../../image/KeypadBack.svg';
import { ReactComponent as CheckSvg } from '../../../image/Check.svg';

export default function KeypadInputView(props) {
  const {
    KeypadRef,
    lastPhone,
    setLastPhone,
    LastRef,
    onClickNumber,
    onClickRemove,
    onClickFindInfo,
  } = props;

  return (
    <TopLevelWrapper ref={KeypadRef}>
      <ExplanatioWholenWrapper>
        <ExplanationWrapper>
          <ExplanationText color='#FF8B48' style={{ marginRight: '6px' }}>예약 확인</ExplanationText>
          <ExplanationText color='#595959' style={{ marginRight: '6px' }}>및</ExplanationText>
          <ExplanationText color='#FF8B48'>출석체크</ExplanationText>
          <ExplanationText color='#595959'>를 위해</ExplanationText>
        </ExplanationWrapper>
        <ExplanationWrapper>
          <ExplanationText color='#FF8B48'>전화번호 뒷자리</ExplanationText>
          <ExplanationText color='#595959'>를 입력해주세요</ExplanationText>
        </ExplanationWrapper>
      </ExplanatioWholenWrapper>
      <InputWrapper>
        <PhoneInput InputRef={LastRef} value={lastPhone} setValue={setLastPhone} />
      </InputWrapper>
      <KeypadWrapper>
        <KeypadLayerWrapper>
          <NumberKey onClick={() => onClickNumber('1')}>
            <NumText>1</NumText>
          </NumberKey>
          <NumberKey onClick={() => onClickNumber('2')}>
            <NumText>2</NumText>
          </NumberKey>
          <NumberKey onClick={() => onClickNumber('3')}>
            <NumText>3</NumText>
          </NumberKey>
        </KeypadLayerWrapper>
        <KeypadLayerWrapper>
          <NumberKey onClick={() => onClickNumber('4')}>
            <NumText>4</NumText>
          </NumberKey>
          <NumberKey onClick={() => onClickNumber('5')}>
            <NumText>5</NumText>
          </NumberKey>
          <NumberKey onClick={() => onClickNumber('6')}>
            <NumText>6</NumText>
          </NumberKey>
        </KeypadLayerWrapper>
        <KeypadLayerWrapper>
          <NumberKey onClick={() => onClickNumber('7')}>
            <NumText>7</NumText>
          </NumberKey>
          <NumberKey onClick={() => onClickNumber('8')}>
            <NumText>8</NumText>
          </NumberKey>
          <NumberKey onClick={() => onClickNumber('9')}>
            <NumText>9</NumText>
          </NumberKey>
        </KeypadLayerWrapper>
        <KeypadLayerWrapper>
          <RemoveKey onClick={onClickRemove}>
            <KeypadBackIcon />
          </RemoveKey>
          <NumberKey onClick={() => onClickNumber('0')}>
            <NumText>0</NumText>
          </NumberKey>
          <OkayKey onClick={onClickFindInfo}>
            <OkayCheckIcon />
          </OkayKey>
        </KeypadLayerWrapper>
      </KeypadWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 74.625%;
  // height: 87.22%;
  height: 92.93%;

  margin-top: 30px;

  z-index: 1;
  opacity: 1;

  // background-color: red;
  transition: all 0.3s ease-in-out;

  @media (max-height: 680px) {
    margin-top: 10px;
    height: 92%;
  }
`;

const ExplanatioWholenWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 7px;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const ExplanationText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 16px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 16px;
  }
  @media (min-height: 640px) {
    font-size: 16px;
  }
  @media (min-height: 720px) {
    font-size: 18px;
  }
  @media (min-height: 760px) {
    font-size: 20px;
  }
  @media (min-height: 800px) {
    font-size: 21px;
  }
  @media (min-height: 1000px) {
    font-size: 26px;
  }
  @media (min-height: 1200px) {
    font-size: 30px;
  }

  @media (max-height: 680px) {
    font-size: 13px;
  }

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 84.89%;

  // gap: 4px;
  gap: 8px;
  margin-top: 43px;
  padding: 12px 0px 12px 0px;

  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #FF8B48;

  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #FF8B48;

  @media (min-height: 320px) {
    gap: 4px;
  }
  @media (min-height: 640px) {
    gap: 6px;
  }
  @media (min-height: 720px) {
    gap: 8px;
  }
  @media (min-height: 760px) {
    gap: 10px;
  }
  @media (min-height: 800px) {
    gap: 12px;
  }
  @media (min-height: 880px) {
    gap: 14px;
  }
  @media (min-height: 940px) {
    gap: 16px;
  }
  @media (min-height: 1000px) {
    gap: 18px;
  }
  @media (min-height: 1200px) {
    gap: 20px;
  }

  @media (max-height: 680px) {
    margin-top: 16px;
    padding: 6px 0px 6px 0px;
    gap: 4px;
  }
`;

const KeypadWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  // margin-top: 80px;
  margin-top: 20px;

  width: 84.89%;
  // height: 54.37%;
  height: 68%;

  @media (min-height: 640px) {
    // margin-top: 40px;
    // height: 64.37%;
    margin-top: 20px;
    height: 60%;
  }
  @media (min-height: 720px) {
    // margin-top: 60px;
    // height: 59.37%;
    margin-top: 30px;
    height: 64%;
  }
  @media (min-height: 860px) {
    // margin-top: 80px;
    // height: 54.37%;
    margin-top: 40px;
    height: 68%;
  }

  @media (max-height: 680px) {
    margin-top: 8px;
    height: 62%;
  }
`;

const KeypadLayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // margin-top: 34px;
  width: 100%;
`;

const NumberKey = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-bottom: 29%;

  width: 29%;

  border-radius: 12px;
  background-color: #FF8B48;

  @media (hover: hover) {
    &:hover {
      background-color: #FF7322;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const RemoveKey = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-bottom: 29%;

  width: 29%;

  border-radius: 12px;
  background-color: #D9D9D9;

  @media (hover: hover) {
    &:hover {
      background-color: #DFDFDF;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const KeypadBackIcon = styled(KeypadBackSvg)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-shrink: 0;

  width: 32px;
  height: 32px;

  & path { stroke: #FFFFFF; }

  @media (min-height: 640px) {
    width: 37px;
    height: 37px;
  }
  @media (min-height: 720px) {
    width: 41px;
    height: 41px;
  }
  @media (min-height: 760px) {
    width: 44px;
    height: 44px;
  }
  @media (min-height: 800px) {
    width: 46px;
    height: 46px;
  }
  @media (min-height: 1000px) {
    width: 55px;
    height: 55px;
  }
  @media (min-height: 1200px) {
    width: 64px;
    height: 64px;
  }
  @media (max-height: 680px) {
    width: 26px;
    height: 26px;
  }
`;

const OkayKey = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-bottom: 29%;

  width: 29%;

  border-radius: 12px;
  background-color: #6DD49E;

  @media (hover: hover) {
    &:hover {
      background-color:#2BCB67;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const OkayCheckIcon = styled(CheckSvg)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-shrink: 0;

  width: 26px;
  height: 20px;

  color: #FFFFFF;

  @media (min-height: 640px) {
    width: 30px;
    height: 23px;
  }
  @media (min-height: 720px) {
    width: 34px;
    height: 26px;
  }
  @media (min-height: 760px) {
    width: 36px;
    height: 28px;
  }
  @media (min-height: 800px) {
    width: 38px;
    height: 29px;
  }
  @media (min-height: 1000px) {
    width: 46px;
    height: 35px;
  }
  @media (min-height: 1200px) {
    width: 54px;
    height: 41px;
  }
  @media (max-height: 680px) {
    width: 22px;
    height: 17px;
  }
`;

const NumText = styled.p`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  border-radius: 12px;

  font-family: NotoSansKR-Bold;
  font-size: 17px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  @media (min-height: 320px) {
    font-size: 27px;
  }
  @media (min-height: 640px) {
    font-size: 29px;
  }
  @media (min-height: 720px) {
    font-size: 31px;
  }
  @media (min-height: 760px) {
    font-size: 32px;
  }
  @media (min-height: 800px) {
    font-size: 33px;
  }
  @media (min-height: 1000px) {
    font-size: 40px;
  }
  @media (min-height: 1200px) {
    font-size: 45px;
  }

  @media (max-height: 680px) {
    font-size: 22px;
  }

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;
